import { ref } from '@vue/composition-api';
import Vue from 'vue';
import useErrors from '@/compositions/useErrors';
import api from '../../api';

const publishers = ref([]);
export default function usePublishers() {
  const { networkError } = useErrors();

  async function fetch(room) {
    try {
      const response = await api.get(`/api/v1/publishers/${room.value}`, {
        params: {
          noCache: new Date().getTime(),
        },
      });
      networkError.value = false;
      publishers.value = response.data;
      return publishers.value;
    } catch (e) {
      networkError.value = true;
      return [];
    }
  }

  function clearPublishers() {
    publishers.value = [];
  }

  function updatePublisher(janusRoomMemberId, data) {
    const publisherIndex = publishers.value.findIndex((p) => p.data.janusRoomMemberId === janusRoomMemberId);
    if (!publishers.value[publisherIndex] || !data) {
      return;
    }
    Vue.set(publishers.value, publisherIndex, Object.assign(publishers.value[publisherIndex], data));
  }

  function addPublisher(publisher) {
    if (publishers.value.some((p) => p._id === publisher._id)) {
      return;
    }
    publishers.value.push(publisher);
  }

  function deletePublisher(publisher) {
    publishers.value = publishers.value.filter((pub) => pub._id !== publisher._id);
  }
  return {
    publishers,
    fetch,
    addPublisher,
    updatePublisher,
    clearPublishers,
    deletePublisher,
  };
}
